import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry'
import GUI from 'lil-gui'
//import typfaceFont from 'three/examples/fonts/helvetiker_bold.typeface.json'


/**
 * Base
 */
// Debug
// const gui = new GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

const axesHelper = new THREE.AxesHelper();
// scene.add(axesHelper)

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()
const matcapTexture = textureLoader.load('/textures/matcaps/4.png')
const matcapTexture2 = textureLoader.load('/textures/matcaps/11.png')
const matcapTexture3 = textureLoader.load('/textures/matcaps/12.png')
//matcapTexture.colorSpace = THREE.SRGBColorSpace

console.log(matcapTexture)

/**
 * Font
 */
const fontLoader = new FontLoader()

const SIZE = 0.95
const BEVEL_SIZE = SIZE*0.1
const BEVEL_THICKNESS = SIZE*0.1;

const container = new THREE.Group();
scene.add(container)



fontLoader.load(
    '/fonts/helvetiker_regular.typeface.json',
    (font) => {
        const textGeometryAttributes = {
            font,
            size:SIZE,
            depth:SIZE*0.5,
            curveSegments:1,
            bevelEnabled: true,
            bevelThickness: BEVEL_THICKNESS,
            bevelSize: BEVEL_SIZE,
            bevelSegments:2
        }
        const textGeometryM = new TextGeometry("M",textGeometryAttributes)
        const textGeometryA = new TextGeometry("A",textGeometryAttributes)
        const textGeometryY = new TextGeometry("Y",textGeometryAttributes)


        // textGeometry.computeBoundingBox()
        // textGeometry.translate(
        //     (textGeometry.boundingBox.max.x - BEVEL_SIZE) * - 0.5,
        //     (1*BEVEL_SIZE),
        //     (textGeometry.boundingBox.max.z - BEVEL_THICKNESS) * - 0.5)

            textGeometryM.center()
            textGeometryA.center()
            textGeometryY.center()

        //const textMaterial = new THREE.MeshBasicMaterial({wireframe:true});
        //textMaterial.wireframe = true
        const material = new THREE.MeshMatcapMaterial({matcap:matcapTexture})
        const material2 = new THREE.MeshMatcapMaterial({matcap:matcapTexture2})
        const material3 = new THREE.MeshMatcapMaterial({matcap:matcapTexture3})
        const sequence = [textGeometryM, textGeometryA, textGeometryY, textGeometryA]
        const materialSequence = [material]
        const kerning = [.0, 0.15, 0, -0.1]

        const grid =17
        for ( let i = 0; i< grid*grid*grid; i++){
            const index = i%4;
            const indexMaterial = materialSequence[i%(materialSequence.length)];
            const geom = sequence[index]
            const px = i%grid - grid*0.41
            const py = Math.floor(i/grid)%grid- grid*0.4;
            const pz = Math.floor(i/(grid*grid));
            const spaceX = 0.9;
            const spaceY = 1.1;
            const donut = new THREE.Mesh(geom, indexMaterial)
            donut.position.x = px*spaceX+kerning[index]*spaceX
            donut.position.y = py*spaceY
            donut.position.z = pz * 1.1
            container.add(donut)
        }

        container.rotation.y = 0.25
        container.rotation.x = 0.35


        
    },
    event => console.log('loading', event),
    error => console.error('font error', error)
)


/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
// const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
const aspect = sizes.width / sizes.height
const frustumSize = 10

const camera = new THREE.OrthographicCamera(
    0,
    0,
    0,
    0,
    0.1,
    1000
)

camera.position.set(0, 0, 50)
scene.add(camera)

function updateCamera() {
    const aspect = sizes.width / sizes.height

    camera.left = frustumSize * aspect / -2
    camera.right = frustumSize * aspect / 2
    camera.top = frustumSize / 2
    camera.bottom = frustumSize / -2

    camera.updateProjectionMatrix()
}

updateCamera()

window.addEventListener('resize', () => {
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    updateCamera()

    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

// Controls
// const controls = new OrbitControls(camera, canvas)
// controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update controls
    //controls.update()

    container.rotation.x = 0.4 +Math.sin(elapsedTime*Math.PI)*0.006
    container.rotation.y = 0.35 +Math.cos(elapsedTime)*0.04

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()